import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
/**
 * AI 对话会话存储管理
 * 基于 localStorage 实现用户隔离的会话持久化
 */

var STORAGE_KEY_PREFIX = 'ai_chat_';
var SETTINGS_KEY_PREFIX = 'ai_chat_settings_';

/**
 * 生成存储 key
 */
function getStorageKey(userId) {
  return "".concat(STORAGE_KEY_PREFIX).concat(userId);
}
function getSettingsKey(userId) {
  return "".concat(SETTINGS_KEY_PREFIX).concat(userId);
}

/**
 * 生成唯一会话 ID
 */
export function generateConversationId() {
  return "conv_".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9));
}

/**
 * 获取用户所有会话列表
 * @param {string} userId 用户ID
 * @returns {Array} 会话列表
 */
export function getConversations(userId) {
  try {
    var data = localStorage.getItem(getStorageKey(userId));
    if (!data) return [];
    var conversations = JSON.parse(data);
    // 按更新时间倒序排列
    return conversations.sort(function (a, b) {
      return b.updatedAt - a.updatedAt;
    });
  } catch (e) {
    console.error('获取会话列表失败:', e);
    return [];
  }
}

/**
 * 获取单个会话
 * @param {string} userId 用户ID
 * @param {string} conversationId 会话ID
 * @returns {Object|null} 会话对象
 */
export function getConversation(userId, conversationId) {
  var conversations = getConversations(userId);
  return conversations.find(function (c) {
    return c.id === conversationId;
  }) || null;
}

/**
 * 保存会话
 * @param {string} userId 用户ID
 * @param {Object} conversation 会话对象
 */
export function saveConversation(userId, conversation) {
  try {
    var conversations = getConversations(userId);
    var index = conversations.findIndex(function (c) {
      return c.id === conversation.id;
    });

    // 更新时间戳
    conversation.updatedAt = Date.now();
    if (index >= 0) {
      conversations[index] = conversation;
    } else {
      conversation.createdAt = conversation.createdAt || Date.now();
      conversations.unshift(conversation);
    }
    localStorage.setItem(getStorageKey(userId), JSON.stringify(conversations));
  } catch (e) {
    console.error('保存会话失败:', e);
  }
}

/**
 * 删除会话
 * @param {string} userId 用户ID
 * @param {string} conversationId 会话ID
 */
export function deleteConversation(userId, conversationId) {
  try {
    var conversations = getConversations(userId);
    var filtered = conversations.filter(function (c) {
      return c.id !== conversationId;
    });
    localStorage.setItem(getStorageKey(userId), JSON.stringify(filtered));
  } catch (e) {
    console.error('删除会话失败:', e);
  }
}

/**
 * 创建新会话
 * @param {string} title 会话标题
 * @returns {Object} 新会话对象
 */
export function createConversation() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '新对话';
  return {
    id: generateConversationId(),
    title: title,
    messages: [],
    createdAt: Date.now(),
    updatedAt: Date.now()
  };
}

/**
 * 获取用户设置
 * @param {string} userId 用户ID
 * @returns {Object} 设置对象
 */
export function getSettings(userId) {
  try {
    var data = localStorage.getItem(getSettingsKey(userId));
    if (!data) {
      return {
        model: null
      }; // 默认值，会从配置中读取
    }
    return JSON.parse(data);
  } catch (e) {
    console.error('获取设置失败:', e);
    return {
      model: null
    };
  }
}

/**
 * 保存用户设置
 * @param {string} userId 用户ID
 * @param {Object} settings 设置对象
 */
export function saveSettings(userId, settings) {
  try {
    localStorage.setItem(getSettingsKey(userId), JSON.stringify(settings));
  } catch (e) {
    console.error('保存设置失败:', e);
  }
}